import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon, Stack, Box, Text, Link } from '@tonic-ui/react';
import { useThemeColorStyle } from '../../hooks/use-theme-color-style';

type SuccessPageProps = {
  contactMethod: 'phone' | 'email';
  customerContacts: string;
  id: string;
};

const SuccessPage = ({ id }: SuccessPageProps): JSX.Element => {
  const { t } = useTranslation('', { keyPrefix: 'bspSupport.supportPage' });
  const colorStyle = useThemeColorStyle();
  const { check } = colorStyle.support;

  return (
    <Stack height="100%" justify="center" align="center" data-id={id} data-telemetry-id={id}>
      <Stack direction="row" spacing="2x" margin="auto" height="max-content">
        <Icon icon="check-bold" width="12x" height="12x" color={check} />
        <Stack direction="column" ml="4x" spacing="2x">
          <Text size="xl" fontWeight="semibold" pb="5x">
            {t('resultsTitle')}
          </Text>
          <Text size="md">{t('resultsMessage')}</Text>
          <Box alignSelf="center" marginTop="3x">
            <Link href="/support">{t('resultsBack')}</Link>
          </Box>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default SuccessPage;
